/**
 * Rubina Irfan - Product Card Quick Add
 * AJAX cart functionality for product cards
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', initQuickAdd);
  
  // Also init on Shopify section reloads
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initQuickAdd);
  }

  function initQuickAdd() {
    // Find all quick-add forms
    const forms = document.querySelectorAll('.ri-quick-add-form');
    
    forms.forEach(form => {
      // Skip if already initialized
      if (form.dataset.quickAddInit) return;
      form.dataset.quickAddInit = 'true';
      
      form.addEventListener('submit', handleQuickAdd);
    });
  }

  async function handleQuickAdd(e) {
    e.preventDefault();
    
    const form = e.target;
    const button = form.querySelector('.ri-product-card__quick-btn');
    const originalText = button.textContent.trim();
    
    // Show loading state
    button.classList.add('ri--adding');
    button.textContent = 'Adding...';
    
    try {
      const formData = new FormData(form);
      const data = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity')) || 1
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      
      const result = await response.json();
      
      // Success state
      button.classList.remove('ri--adding');
      button.classList.add('ri--success');
      button.textContent = 'Added ✦';
      
      // Dispatch custom event for cart drawer update
      document.dispatchEvent(new CustomEvent('ri:cart:updated', {
        detail: { 
          item: result,
          total_items: result.quantity 
        }
      }));
      
      // Revert after 1.2s
      setTimeout(() => {
        button.classList.remove('ri--success');
        button.textContent = originalText;
      }, 1200);
      
    } catch (error) {
      console.error('Quick add error:', error);
      
      // Error state
      button.classList.remove('ri--adding');
      button.classList.add('ri--error');
      button.textContent = 'Unavailable';
      
      // Revert after 1.2s
      setTimeout(() => {
        button.classList.remove('ri--error');
        button.textContent = originalText;
      }, 1200);
    }
  }
})();
